import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('relay-migration-issue-header-and-parent');
	},
};
